export const PUBLIC_API_SLICE_NAME = "publicApi"
